<template>
    <div>
        <div class="user_section">
            <div class="col-12">
                <div class="img-wrapper">
                    <img :src="avatar" :alt="$t('table.profile_picture')" class="rounded-circle">
                </div>
            </div>
            <div class="col-12 text-center">
                <multiselect v-if="rolesLength(2)" v-model="userSelectedRole" :options="userRoles" deselect-label="" placeholder="" select-label="" track-by="role_id" label="role_name" ></multiselect>
                <div class="font-weight-bold" v-if="rolesLength(0)">{{ $t('general.no_roles_available') }}</div>
                <div class="font-weight-bold" v-if="rolesLength(1)">{{userRoles[0].role_name}}</div>
            </div>
            <!--
            <div class="col-12 text-center" v-if="!this.$store.state.user.user.is_super_admin">
                <multiselect v-if="rolesLength(2)" v-model="userSelectedRole" :options="userRoles" deselect-label="" select-label="" track-by="id" label="name" ></multiselect>
                <div class="font-weight-bold" v-if="rolesLength(0)">{{ $t('general.no_roles_available') }}</div>
                <div class="font-weight-bold" v-if="rolesLength(1)">{{userRoles[0].role_name}} {{ $t('general.for') }} {{userRoles[0].company_name}}</div>
            </div>
            <div class="col-12 text-center" v-if="this.$store.state.user.user.is_super_admin">
                <b>{{$t('general.super_admin')}}</b>
            </div>
            -->
            <div class="clearfix"></div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';

    import Multiselect from 'vue-multiselect';

    export default {
        components: {
            Multiselect,
        },
        name: "user_profile2",
        data() {
            return {
            }
        },
        computed: {
            userRoles: {
                get: function () {
                    let avatar = this.$store.getters.getUserRoles;
                    return avatar;
                }
            },
            userSelectedRole: {
                get: function () {
                    let role = this.$store.state.userSelectedRole;
                    return role;
                },
                set: function(val) {
                    this.updateUserRole(val);
                    return true;
                }
            },
            avatar: {
                get: function () {
                    let avatar = this.$store.getters.getUserAvatar;
                    return avatar;
                }
            },
        },
        watch: {
            userRoles: {
                immediate: true,

                handler(newVal, oldVal) {
                }
            },
            userSelectedRole: {
                immediate: true,
                deep: true,

                handler(newVal, oldVal) {
                }
            },
            avatar: {
                immediate: true,
                deep: true,

                handler(newVal, oldVal) {
                }
            },
        },
        methods: {
            rolesLength(len) {
                switch (len) {
                    case 0:
                        return this.userRoles.length == 0;
                        //return Object.keys(this.userRoles).length == 0;
                        break;
                    case 1:
                        return this.userRoles.length == 1;
                        //return Object.keys(this.userRoles).length == 1;
                        break;
                    default://>1
                        return this.userRoles.length > 1;
                        //return Object.keys(this.userRoles).length > 1;
                        break;
                }
            },
            updateUserRole(role) {
                if (role == null) {
                    return;
                }

                this.$store.commit('SET_USER_SELECTED_COMPANY', role);
                this.$store.dispatch('saveUserSelectedRole', role)
                this.$router.push('/');
            }
        }
    }
</script>

<style scoped lang="scss">
/*user section*/
@import "../../css/customvariables";

.user_section {
    padding: 15px 20px;

    .img-wrapper{
        width: 100px;
        border-radius:50%;
        padding:7px;
        margin:auto;
    }
    img {
        width: 84px;
        border: 2px solid #ccc;
    }

    p {
        font-size: 15px;
    }
    .leftuser_icons .logout_padd{
        padding: 1px !important;
    }
}
.user_name_max {
    text-transform:uppercase;
    font-weight:700;
    max-width: 210px;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis;
    margin: 0 0 -4px;
    padding-top: 2px;
    padding-bottom: 5px;
}

.leftuser_icons div {
    cursor: pointer;
    padding: 1px 12px;
    font-size:18px;
    background-color: transparent;
    margin-right: 3px;
    border-radius: 50px;
    margin: auto;
    width: 100%;
    display: inline;
}
.user_name_max,
.leftuser_icons i{
    color:$menu_color;
}
</style>

<style lang="css">
span.multiselect__option--selected:after {
    display: none!important;
}
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


// WEBPACK FOOTER //
// src/components/layouts/left-side/left-profile/user_profile2.vue